
import { AuthorityType, Client, Permission } from 'ah-api-gateways';
import { Component, Prop, Vue } from 'vue-property-decorator';

type OboAction = 'trade' | 'trades' | 'payment' | 'collateral-management' | 'beneficiary-management' | 'documents';

/**
 * On behalf of client actions
 *
 * Used by clients to executed action on behalf of a client
 *
 */
@Component
export default class ClientOnBehalfOfActions extends Vue {
  @Prop({ required: true }) client!: Client;

  @Prop({ default: [] }) clientPermissions!: Permission[];

  get clientAllowsTrades() {
    const permission = this.clientPermissions.find(
      (permission) => permission.authority === AuthorityType.TRADE_ON_BEHALF_OF
    );
    return permission ? permission.allow : false;
  }

  get clientAllowsPayments() {
    const permission = this.clientPermissions.find(
      (permission) => permission.authority === AuthorityType.PAY_ON_BEHALF_OF
    );
    return permission ? permission.allow : false;
  }

  private goTo(location: OboAction) {
    const baseUrl = `/admin/activity/clients/obo`;
    this.$router.push({ path: `${baseUrl}/${this.client.id}/${location}` });
  }
}
